/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import { ETheme } from '@datatype/type';
import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
import { TAdminClozeType } from '@datatype/admin/api-type';
import TextBlock from '@component/common/block/text-block';
import Chip from '@design-system/chip';

interface IProps {
  clozeType: TAdminClozeType | null;
  languageCode: EApiLanguageCode | null;
  handleClozeTypeChange: (clozeType: TAdminClozeType | null) => void;
  handleLanguageChange: (languageCode: EApiLanguageCode | null) => void;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  align-items: center;
`;

const Group = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  align-items: center;
`;

const Divider = styled.div`
  width: 1px;
  height: 18px;
  background-color: ${color.GRAY_3};
`;

const ClozeFilter: React.FC<IProps> = ({
  clozeType,
  languageCode,
  handleClozeTypeChange,
  handleLanguageChange,
}) => {
  return (
    <Wrapper>
      <Group>
        <TextBlock text='유형' design={{ text: { size: 'small', color: color.BLACK_4 } }} />
        <Chip
          text='전체'
          size='small'
          isSelected={clozeType === null}
          handleClick={() => handleClozeTypeChange(null)}
          theme={ETheme.BROWN}
        />
        <Chip
          text='어휘'
          size='small'
          isSelected={clozeType === 'vocabulary'}
          handleClick={() => handleClozeTypeChange('vocabulary')}
          theme={ETheme.BROWN}
        />
        <Chip
          text='문법'
          size='small'
          isSelected={clozeType === 'grammar'}
          handleClick={() => handleClozeTypeChange('grammar')}
          theme={ETheme.BROWN}
        />
      </Group>
      <Divider />
      <Group>
        <TextBlock text='언어' design={{ text: { size: 'small', color: color.BLACK_4 } }} />
        <Chip
          text='전체'
          size='small'
          isSelected={languageCode === null}
          handleClick={() => handleLanguageChange(null)}
          theme={ETheme.BROWN}
        />
        <Chip
          text='EN'
          size='small'
          isSelected={languageCode === EApiLanguageCode.ENGLISH}
          handleClick={() => handleLanguageChange(EApiLanguageCode.ENGLISH)}
          theme={ETheme.BROWN}
        />
        <Chip
          text='JA'
          size='small'
          isSelected={languageCode === EApiLanguageCode.JAPANESE}
          handleClick={() => handleLanguageChange(EApiLanguageCode.JAPANESE)}
          theme={ETheme.BROWN}
        />
      </Group>
    </Wrapper>
  );
};

export default ClozeFilter;
